import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';

@Component({
    selector: 'cube',
    templateUrl: 'cube.component.html',

})

export class CubeComponent {

    public pageNo: number = 0;
    public pageSize: number = 10;
    public totalCubes: number = 0;
    public sPage: number = 0;
    public cubeReg: string = '';
    public lastRegex: string = '';
    public cubeData: any = { id: null, name: '', description: '', deleted: 0, dataSourceId: null };
    public mainPage: boolean = true;
    public cubePage: boolean = false;
    public datePicker: boolean = false;
    public currentPage: number = 1;
    public selectedCubeId: number;
    public startingPage: number = 0;
    public endingPage: number = 0;
    public entityOpsFlag: boolean = false;
    public cubeList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public dataSourceList: any = [];
    public isEdit: boolean = false;
    public dimensionList: any = [];
    public recordList: any = [];
    public recordObject: any = {};
    public measureList: any = [];
    public measIndex: number = -1;
    public dimInd: number = -1;
    public selectedDim: any;
    public cubeMeasureDataList = [];
    public filteredMeasureMap = new Map();
    public filteredDimensionMap = new Map();
    public measurePage: boolean = false;
    public measureData: any;
    public dimensionPage: boolean = false;
    public dimensionData: any;
    public openDimensionMapping: any;
    public openMeasureMapping: any;
    public dataVersionType: string = '';

    public cubeMeasureData: any = {
        measureId: 'none', measureData: null, recordFormatFieldId: 'none',
        recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
    };
    public recordFormatId: any;
    public cubeDimensionUsageData: any = {
        dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none', name: null,
        recordFormatField: null, cubeId: null, deleted: 0
    };
    public cubeDimensionUsageList: any = [];
    public referencevariable: String = 'none';
    public loader: boolean = false;
    public totalPages: number = 0;

    public constructor(public cubeService: MDMService,
        public toastr: ToasterComponent,
        public ngbDataConv: NgbDateConverter,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    public dataVersionDate: NgbDateStruct = { day: null, month: null, year: null };

    public ngOnInit() {
        if (this.cubeService.isBIAdmin) {
            this.loadCube();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedCubeId == null) {
            this.selectedCubeId = event.target.id;
        } else {
            this.selectedCubeId = null;
        }
    }

    public closeDropDown(event){
        this.selectedCubeId = null;
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.cubeReg != '') {
            this.searchPCube();
        } else {
            this.loadCube();
        }
        this.setEndingPage(this.totalCubes);
    }

    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalCubes / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }

        this.loadCube();
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    public loadCube() {
        let self = this;
        return new Promise((resolve) => {
            self.loader = true;
            this.cubeService.getDataByPage(BiUrls.CUBE, self.pageNo, self.pageSize).then((res) => {
                self.cubeList = [];
                self.totalCubes = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.cubeList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.totalCubes = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.parseDataVersionDates();
                self.setEndingPage(self.totalCubes);
                self.loader = false;
                resolve('completed');
            }, (err) => {
                console.error(err);
            });
        });
    }

    public parseDataVersionDates() {
        let self = this;
        for (let cb of self.cubeList) {
            cb.dataVersion = new Date(cb.dataVersion);
        }
    }

    // By Lalu
    public searchPCube() {
        return new Promise(resolve => {
            let self = this;
            self.mainPage = true;
            self.loader = true;
            self.cubeList = [];
            if (self.cubeReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.cubeReg;
            let resu = self.cubeService.search(BiUrls.CUBE, BiUrls.SEARCH_P_CUBE,
                self.cubeReg, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedPCube(res);
                    self.loader = false;
                }, (err) => {
                    console.error(err);
                });
            resolve('completed');
        });
    }

    // By Lalu
    public loadSearchedPCube(res) {
        let self = this;
        self.cubeList = (res != undefined) ? res.data.pageElements : [];
        self.totalCubes = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalCubes);
    }

    public loadRecordFormat() {
        return new Promise((resolve) => {
            let self = this;
            this.cubeService.onStartUp(BiUrls.RECORDFORMAT).then((res) => {
                self.recordList = res.data;
                self.loadMeasures();
                self.loadDimensions();
                resolve('completed');
            });
        });
    }

    public loadDimensions() {
        return new Promise((resolve) => {
            let self = this;
            this.cubeService.onStartUp(BiUrls.DIMENSION).then((res) => {
                self.dimensionList = res != undefined && res.data != undefined ? res.data : [];
                for (let d of self.dimensionList) {
                    for (let cdu of self.cubeDimensionUsageList) {
                        if (d.id == cdu.dimensionId) {
                            let filtered = d.dimHierarchyData[0]
                                .dimHierarchyLevelData.filter(
                                    (item) => cdu.dimHierarchyLevelData &&  (cdu.dimHierarchyLevelData.id == item.id));
                            for (let lvl of filtered) {
                                self.filteredDimensionMap.set(lvl.id, lvl);
                                self.dimInd = d.dimHierarchyData[0]
                                    .dimHierarchyLevelData.indexOf(lvl);
                                d.dimHierarchyData[0]
                                    .dimHierarchyLevelData.splice(self.dimInd, 1);
                            }
                            //d.dimHierarchyData[0].dimHierarchyLevelData = filtered;
                        }
                    }
                }
                resolve('completed');
            });
        });
    }

    public loadMeasures() {
        return new Promise((resolve) => {
            let self = this;
            this.cubeService.onStartUp(BiUrls.MEASURE).then((res) => {
                self.measureList = res != undefined && res.data != undefined ? res.data : [];
                for (let cm of self.cubeMeasureDataList) {
                    for (let m of self.measureList) {
                        if (m.id == cm.measureId) {
                            self.filteredMeasureMap.set(m.id, m);
                            self.measIndex = self.measureList.indexOf(m);
                            self.measureList.splice(self.measIndex, 1);
                        }
                    }
                }
                resolve('completed');
            });
        });
    }

    public addNewCube() {
        console.log('On Add Controller ...');
        let self = this;
        self.mainPage = false;
        self.cubePage = true;
        this.cubeData = { id: null, name: '', description: null, dataSourceId: '', deleted: 0 };
    }

    public onSave() {
        console.log('On Save Controller ...');
        let self = this;
        self.processDataVersion('save');
        let validate: any = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        } else {
            self.saveButton = true;
            self.loader = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.cubeService.update(BiUrls.CUBE, self.cubeData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                self.cubeService.save(BiUrls.CUBE, self.cubeData).then((res) => {
                    console.log(self.pageNo);
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalCubes / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            this.totalPages;
        self.currentPage = self.pageNo + 1;
        let text = type == 'new' ? 'Cube saved successfully' : 'Changes saved successfully';
        if (self.cubeReg != '') {
            self.searchPCube().then(res => {
                self.loaderAfterSaveOrUpdate();
            });
        } else {
            self.loadCube().then((res) => {
                self.loaderAfterSaveOrUpdate();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else if (result.status != 500) {
                    self.toastr.showError(result.statusText);
                }
            });
        }
        self.currentPage = self.pageNo + 1;
    }

    public loaderAfterSaveOrUpdate() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.cubePage = false;
        self.isEdit = false;
        self.cubeMeasureDataList = [];
        self.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        self.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null,
            recordFormatFieldId: 'none', recordFormatField: null, cubeId: null, deleted: 0
        };
        self.referencevariable = 'none';
        self.cubeDimensionUsageList = [];
        self.loader = false;
    }

    public clickEdit(cubeData) {
        let self = this;
        self.loader = true;
        self.selectedCubeId = null;
        self.cubeService.getDataById(BiUrls.CUBE, cubeData.id).then((res) => {
            console.log(res.data)
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load Cube');
                self.mainPage = true;
            } else {
                self.loadRecordFormat();
                self.isEdit = true;
                self.mainPage = false;
                self.cubePage = true;
                self.cubeData = JSON.parse(JSON.stringify(res.data));
                self.processDataVersion('edit');
                console.log(self.cubeData);
                self.cubeMeasureDataList = self.cubeData.cubeMeasureData;
                self.cubeDimensionUsageList = self.cubeData.cubeDimensionUsageData;
                if (self.cubeData.recordFormatId != undefined &&
                    self.cubeData.recordFormatId != null) {
                    self.recordFormatId = self.cubeData.recordFormatId;
                    self.onSelectRecord(self.cubeData.recordFormatId);
                } else {
                    self.recordFormatId = 'none';
                }
                delete self.cubeData.schema;
                delete self.cubeData.facts;
                delete self.cubeData.schemaName;
                delete self.cubeData.status;
                delete self.cubeData.factNames;
                delete self.cubeData.dataSourceName;
            }
            self.loader = false;
        }, (err) => {
            console.error(err);
        });
    }

    public onBack() {
        this.referencevariable = 'none';
        this.mainPage = true;
        this.cubePage = false;
        this.selectedCubeId = null;
        this.isEdit = false;
        this.recordObject = {};
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap.clear();
        this.filteredDimensionMap.clear();
        this.cubeDimensionUsageList = [];
        this.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        this.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0
        };
    }

    public delete(cube, removeDim, removeMeasure) {
        let self = this;
        self.loader = true;
        self.cubeService.delete(BiUrls.CUBE, cube.id + "/" + removeDim + "/" + removeMeasure).then((response) => {
            self.toastr.showSuccess(cube.name + ' removed successfully');
            self.pageNo = self.cubeList.length == 1 ? self.totalCubes == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadCube();
            self.loader = false;
        }, (err) => {
            self.toastr.showError('Unable to remove Cube : ' + err.errorCode);
        });
    }

    public removeCube(cube) {
        let r = confirm('Are you sure you want to delete the cube ' + cube.name + '?');
        if (r == true) {
            this.delete(cube, 0, 0);
        }
    }

    public removeCubeWithDimsAndMeasures(cube) {
        let r = confirm('Are you sure you want to delete the cube ' + cube.name + ' along with dimensions and measures associated with it?');
        if (r == true) {
            this.delete(cube, 1, 1);
        }
    }

    public validater() {
        if (this.cubeData.name == undefined || this.cubeData.name.trim() == '') {
            return 'Please enter the name for cube';
        } else {
            this.cubeData.name = this.cubeData.name.trim();
            this.cubeData.description = this.cubeData.description != undefined ?
                this.cubeData.description.trim() : null;
            this.cubeData.recordFormatId = this.recordFormatId == 'none' ? null
                : this.recordFormatId;
            this.cubeData.cubeMeasureData = this.cubeMeasureDataList;
            this.cubeData.cubeDimensionUsageData = this.cubeDimensionUsageList;
            return '';
        }
    }

    public onSelectRecord(id) {
        let self = this;
        self.recordFormatId = id;
        return new Promise((resolve) => {
            this.cubeService.getObjectById(BiUrls.RECORDFORMAT + '/' + self.recordFormatId).then((res) => {
                self.recordObject = res.data;
                if (self.recordObject.dataSourceData) {
                    self.cubeData['dataSourceData'] = self.recordObject.dataSourceData;
                } else {
                    delete self.cubeData['dataSourceData'];
                }
            }, (err) => {
                delete self.cubeData['dataSourceData'];
            });
            resolve('completed');
        });
    }

    public confirmChangeOfRecordFormat(event) {
        let r = this.recordFormatId == 'none' ? true :
            confirm('Are you sure you want to change the Record Format? ' +
                'It will erase all the Mappings of Measure and Dimension.');
        if (r) {
            this.cubeDimensionUsageList = [];
            this.cubeMeasureDataList = [];
            this.recordObject = {};
            delete this.cubeData['dataSourceData'];
            if (event.target.value != 'none') {
                this.toastr.showSuccess(this.recordFormatId == 'none' ? 'Record Format added' :
                    'Record Format changed');
                this.onSelectRecord(event.target.value);
            } else {
                this.toastr.showWarning('Record Format removed');
                this.recordFormatId = 'none';
            }
        } else {
            event.target.value = this.recordFormatId;
        }

    }

    public onSelectMeasure(event) {
        for (let measure of this.measureList) {
            if (measure.id == Number(event.target.value)) {
                this.cubeMeasureData['measureData'] = measure;
                this.filteredMeasureMap.set(measure.id, measure);
                this.measIndex = this.measureList.indexOf(measure);
            }
        }
    }

    public onSelectDimenasion(event) {
        let ids = event.target.value.split('_');
        for (let dim of this.dimensionList) {
            if (dim.id == Number(ids[0])) {
                for (let levels of dim.dimHierarchyData[0].dimHierarchyLevelData) {
                    if (levels.id == Number(ids[1])) {
                        this.cubeDimensionUsageData['dimensionData'] = dim;
                        this.cubeDimensionUsageData['dimensionId'] = dim.id;
                        this.cubeDimensionUsageData['dimHierarchyLevelId'] = levels.id;
                        this.cubeDimensionUsageData['dimHierarchyLevelData'] = levels;
                        this.filteredDimensionMap.set(levels.id, levels);
                        this.dimInd = dim.dimHierarchyData[0].dimHierarchyLevelData.indexOf(levels);
                        this.selectedDim = dim;
                        //dim.dimHierarchyData[0].dimHierarchyLevelData.splice(index, 1);
                    }
                }
            }
        }
    }

    public onSelectField(event, param) {

        for (let record of this.recordList) {

            if (record.id == this.recordFormatId && record.recordFormatFieldData != undefined) {

                for (let field of record.recordFormatFieldData) {
                    if (field.id == Number(event.target.value)) {
                        if (param == 'measure') {
                            this.cubeMeasureData['recordFormatField'] = field;
                        } else {
                            this.cubeDimensionUsageData['recordFormatField'] = field;
                        }
                    }
                }
            }
        }
    }

    public addFieldForMeasure() {
        let validate: any = this.validaterMeasureRecordFormat();
        if (validate != '') {
            this.toastr.showError(validate);
            console.error(validate);
        } else {
            this.measureList.splice(this.measIndex, 1);
            this.cubeMeasureData.cubeId = this.cubeData.id;
            this.cubeMeasureDataList.push(this.cubeMeasureData);
            this.cubeMeasureData = {
                measureId: 'none', measureData: null, recordFormatFieldId: 'none',
                recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
            };
            this.toastr.showSuccess('Measure linked');
            this.measIndex = -1;
        }
    }

    public addFieldForDimension() {
        let validate: any = this.validaterDimensionRecordFormat();
        if (validate != '') {
            this.toastr.showError(validate);
            console.error(validate);
        } else {
            this.selectedDim.dimHierarchyData[0].dimHierarchyLevelData.splice(this.dimInd, 1);
            this.cubeDimensionUsageData.cubeId = this.cubeData.id;
            this.cubeDimensionUsageList.push(this.cubeDimensionUsageData);
            this.cubeDimensionUsageData = {
                dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none',
                recordFormatField: null, cubeId: null, deleted: 0
            };
            this.toastr.showSuccess('Dimension linked');
        }
        this.referencevariable = 'none';
    }

    public removeCubeMeasure(event, cubeMeasure) {
        let r = confirm('Are you sure you want to remove this field ' +
            cubeMeasure.measureData.name + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Linking of measure removed successfully');
            this.measureList.push(this.filteredMeasureMap.get(cubeMeasure.measureData.id));
            let index = this.cubeMeasureDataList.indexOf(cubeMeasure);
            this.cubeMeasureDataList.splice(index, 1);
        }
    }

    public removeCubeDimension(event, cubeDimension) {
        let r = confirm('Are you sure you want to remove this field ' +
            cubeDimension.dimHierarchyLevelData.displayName + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Linking of dimension removed successfully');
            console.log(cubeDimension);
            let dimIndex = this.dimensionList.indexOf(cubeDimension.dimensionData);
            for (let d of this.dimensionList) {
                if (d.id == cubeDimension.dimensionId) {
                    d.dimHierarchyData[0].dimHierarchyLevelData.push(this.filteredDimensionMap.get(cubeDimension.dimHierarchyLevelId))
                }
            }
            let index = this.cubeDimensionUsageList.indexOf(cubeDimension);
            this.cubeDimensionUsageList.splice(index, 1);
        }
    }

    public validaterMeasureRecordFormat() {
        if (this.cubeMeasureData.measureId == 'none' ||
            this.cubeMeasureData.recordFormatFieldId == 'none') {
            return 'Please select both measure and record format field to add';
        } else {
            return '';
        }
    }

    public validaterDimensionRecordFormat() {
        if (this.cubeDimensionUsageData['dimensionId'] == 'none' ||
            this.cubeDimensionUsageData['recordFormatFieldId'] == 'none') {
            return 'Please select both dimension and record format field to add';
        } else {
            return '';
        }
    }

    editMeasure(cubeMeasure) {
        this.cubePage = false;
        this.measurePage = true;
        this.measureData = cubeMeasure.measureData;
    }

    comingBackFromMeasureScreen() {
        this.cubePage = true;
        this.measurePage = false;
        this.openMeasureMapping = "measure";
        this.openDimensionMapping = '';
    }

    afterSavingMeasure(event) {
        let self = this;
        this.cubePage = true;
        this.measurePage = false;
        this.cubeMeasureDataList.forEach(measure => {
            if (measure.measureData.id == event.data.id) {
                measure.measureData = event.data;
            }
        })
        this.openMeasureMapping = "measure";
        this.openDimensionMapping = '';
    }

    afterSavingDimension(event) {
        let self = this;
        this.cubePage = true;
        this.dimensionPage = false;
        this.cubeDimensionUsageList.forEach(dim => {
            if (dim.dimensionData.id == event.data.id) {
                dim.dimensionData = event.data;
            }
        });
        this.openDimensionMapping = 'dimension';
        this.openMeasureMapping = '';
    }

    comingBackFromDimensionScreen() {
        this.openDimensionMapping = 'dimension';
        this.openMeasureMapping = '';
        this.cubePage = true;
        this.dimensionPage = false;
    }

    editDimension(cubeMeasure) {
        this.cubePage = false;
        this.dimensionPage = true;
        this.dimensionData = cubeMeasure.dimensionData;
    }

    clearCacheForCube(cube) {
        let self = this;
        self.cubeService.clearCache('ads/clearDataCache/' + cube.id).then((res) => {
            if (res.success) {
                self.toastr.showSuccess("Cube Cache cleared successfully!");
            } else {
                self.toastr.showError("Unable To Clear Cube Cache!");
            }
        });
    }

    clearCache() {
        let self = this;
        self.cubeService.clearCache('ads/clearDataCache').then((res) => {
            if (res.success) {
                self.toastr.showSuccess("Cache cleared successfully!");
            } else {
                self.toastr.showError("Unable To Clear Cache!");
            }
        });
    }

    getTitle(type) {
        let self = this;
        if (type == 'measure') {
            return 'Cube Measure Mapping ( ' + self.cubeMeasureDataList.length + ' )';
        } else {
            return 'Cube Dimension Mapping ( ' + self.cubeDimensionUsageList.length + ' )';
        }
    }

    processDataVersion(action) {
        let self = this;
        if (action == 'save') {
            let date = Date.parse(self.ngbDataConv.toModel(self.dataVersionDate));
            self.cubeData.dataVersion = self.dataVersionType == 'Static' ? date : null;
            self.cubeData.dataVersionType = self.dataVersionType;
        } else {
            if (self.cubeData.dataVersionType != undefined && self.cubeData.dataVersionType == 'Static') {
                self.dataVersionType = 'Static';
                let dateTime = new Date(self.cubeData.dataVersion);
                let strDate = dateTime.getUTCDate() + '-' +
                    (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
                self.dataVersionDate = self.ngbDataConv.fromModel(strDate);
            } else {
                self.dataVersionType = 'Dynamic';
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/cube.component.ts